import { createContext } from "react";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { ITrademarkManager, ITrademarkManagerDetails } from "../../models/trademark-manager/response";
import { ITrademarkManagerQuery } from "../../models/trademark-manager/query";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../utils/helpers/constants";
import { ICreateTradmarkManager, IUpdateTradmarkManager } from "../../models/trademark-manager/request";

export type TrademarkManagerLoading = "list" | "details" | "create" | "update" | "delete";

export interface IInternalState {
  loading: TrademarkManagerLoading[];

  list?: IBaseListingResponse<ITrademarkManager>;
  query: ITrademarkManagerQuery;

  details?: ITrademarkManagerDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: ITrademarkManagerDetails) => void;

    createTradmarkManager: (request: ICreateTradmarkManager) => void;
    updateTradmarkManager: (id: number, request: IUpdateTradmarkManager) => void;
    deleteTradmarkManager: (id: number) => void;
    exportExcel: (data: any) => any;

    setSearch: (search?: string) => void;
    setQuery: (query: ITrademarkManagerQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    exportExcel: DEFAULT_FUNCTION,

    createTradmarkManager: DEFAULT_FUNCTION,
    updateTradmarkManager: DEFAULT_FUNCTION,
    deleteTradmarkManager: DEFAULT_FUNCTION,

    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const TrademarkManagerContext = createContext(externalState);

export default TrademarkManagerContext;